import { useMutation } from '@apollo/client';
import Button from '../components/Button';
import { Modal, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { unarchiveTopicCache } from '../utilities/cache';
import { UNARCHIVE_TOPIC } from '../utilities/mutations';
import { useSpaceContext } from '../contexts/space';

const UnarchiveTopicModal = ({ topicId, spaceSlug, onClose }) => {
  const toast = useToast();
  const { spaceVars } = useSpaceContext();
  const [unarchiveTopic] = useMutation(UNARCHIVE_TOPIC, {
    variables: { id: topicId },
    update: (cache, { data: { unarchiveTopic } }) =>
      unarchiveTopicCache(spaceVars, spaceSlug, cache, unarchiveTopic),
  });

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()} isDanger>
      <ModalName>Unarchive topic</ModalName>
      <ModalPart>Are you sure you want to unarchive this topic?</ModalPart>
      <ModalPart>
        <Button onClick={() => close()} isExtended>
          Cancel
        </Button>
        <Button
          data-autofocus
          onClick={async () => {
            try {
              await unarchiveTopic();
            } catch (error) {
              toast({ children: error.message });

              return;
            }

            if (onClose) {
              onClose();
            }
          }}
          isDanger
          isExtended
        >
          Unarchive
        </Button>
      </ModalPart>
    </Modal>
  );
};

export default UnarchiveTopicModal;
